import getKeysForKeyboardShortcutsMode from './getKeysForKeyboardShortcutsMode';
import shouldPreventCallback from './shouldPreventCallback';
import { HotkeyCommand, Hotkeys } from '../types/HotkeyCommand';
import UseKeydownHandlerOptions from '../types/UseKeydownHandlerOptions';

export default function bindEventWithMousetrap(
    target: React.Component<any, any, any>,
    mousetrap: any,
    command: HotkeyCommand | Hotkeys,
    handler: (evt: React.KeyboardEvent) => void,
    {
        stopPropagation = true,
        preventDefault = true,
        allowHotkeyOnTextFields = false,
    }: UseKeydownHandlerOptions = {}
) {
    const keys = getKeysForKeyboardShortcutsMode(command);
    if (keys) {
        mousetrap.bind(keys, function(this: React.Component<any, any, any>, evt: KeyboardEvent) {
            if (shouldPreventCallback(evt, allowHotkeyOnTextFields)) {
                return;
            }
            if (stopPropagation) {
                evt.stopPropagation();
            }
            if (preventDefault) {
                evt.preventDefault();
            }
            handler.call(target, evt);
        });
    }
}
